// Header scroll
const header = document.getElementById('header');
window.addEventListener('scroll', () => header.classList.toggle('scrolled', window.scrollY > 20));

// Scroll animations
const obs = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
}, { threshold: 0.05, rootMargin: '0px 0px -30px 0px' });
document.querySelectorAll('.fade-up').forEach(el => obs.observe(el));

// Wishlist toggle
document.querySelectorAll('.product-wishlist').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();
    btn.textContent = btn.textContent === '♡' ? '♥' : '♡';
    btn.style.color = btn.textContent === '♥' ? '#E8967A' : '';
  });
});

// Category nav scroll
function scrollToCat(id) {
  document.querySelectorAll('.cat-btn').forEach(b => b.classList.remove('active'));
  event.target.classList.add('active');
  if (id === 'all') { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

// Hamburger menu
const hamburgerBtn = document.getElementById('hamburger');
const mainNav = document.getElementById('mainNav');
hamburgerBtn.addEventListener('click', () => {
  const isOpen = mainNav.classList.toggle('open');
  hamburgerBtn.classList.toggle('active');
  document.body.style.overflow = isOpen ? 'hidden' : '';
});
// Close mobile nav when clicking a link
document.querySelectorAll('.nav-link').forEach(link => {
  link.addEventListener('click', () => {
    mainNav.classList.remove('open');
    hamburgerBtn.classList.remove('active');
    document.body.style.overflow = '';
  });
});

// Search filter
document.getElementById('searchInput').addEventListener('input', function() {
  const q = this.value.toLowerCase();
  document.querySelectorAll('.product-card').forEach(card => {
    const text = card.textContent.toLowerCase();
    card.style.display = text.includes(q) ? '' : 'none';
  });
});